export enum LogType {
  Trace = 0,
  Assert = 1,
}
